import organization from "@/services/organization";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        saving: false,
        errors: null,
        offlineCapabilitiesSettings: null
    },
    getters: {
        organizationLoading: (state) => state.loading,
        organizationSaving: (state) => state.saving,
        organizationErrors: (state) => state.errors,
        offlineCapabilitiesSettings: (state) => state.offlineCapabilitiesSettings
    },
    mutations: {
        setLoading(state, value) {
            state.loading = value;
        },
        setSaving(state, value) {
            state.saving = value;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        setOfflineCapabilitiesSettings(state, value) {
            state.offlineCapabilitiesSettings = value;
        }
    },
    actions: {
        async getOfflineCapabilitiesSettings({ commit }) {
            commit("setLoading", true);
            commit("setOfflineCapabilitiesSettings", null);
            commit("setErrors", null);

            try {
                const { settings } = await organization.getOfflineCapabilitiesSettings();

                commit("setOfflineCapabilitiesSettings", settings);
            } catch (errors) {
                commit(
                    "setErrors",
                     _.get(errors, "errors.message", "Oops, something went wrong.")
                );
            } finally {
                commit("setLoading", false);
            }
        },
        async saveOfflineCapabilitiesSettings({ commit }, payload) {
            commit("setSaving", true);
            commit("setErrors", null);

            try {
                await organization.saveOfflineCapabilitiesSettings(payload);
            } catch (errors) {
                commit(
                    "setErrors",
                     _.get(errors, "errors.message", "Oops, something went wrong.")
                );
            } finally {
                commit("setSaving", false);
            }
        }
    }
};
